export default {
  common: {
    brand: 'USFans Spreadsheet',
    tagline: 'Niezależne centrum zasobów',
    navHome: 'Strona główna',
    navShoppingGuide: 'Przewodnik zakupowy',
    navGuides: 'Poradniki',
    navCategories: 'Kategorie',
    navResources: 'Zasoby',
    navReview: 'Recenzja',
    navFaq: 'FAQ',
    visitMain: 'Odwiedź główną stronę',
    language: 'Język',
    mainSiteUrl: 'https://kaspreadsheet.com',
    footerAbout: 'USFans Spreadsheet to niezależne źródło, które porządkuje amerykańskie gadżety i odzież dla fanów w prostą, łatwą do przeglądania strukturę — dzięki czemu szybciej znajdziesz to, czego szukasz.',
    footerQuickLinks: 'Szybkie linki',
    footerCategories: 'Kategorie',
    footerDisclaimer: 'Ta strona jest niezależnym źródłem informacji i nie jest oficjalnie powiązana z żadną marką, chyba że wyraźnie to zaznaczono. Wszystkie linki do produktów prowadzą do głównej strony.',
    footerRights: 'Wszelkie prawa zastrzeżone.',
    notFoundTitle: 'Nie znaleziono tej strony',
    notFoundText: 'Strona, której szukasz, nie istnieje. Wróć, aby przeglądać centrum zasobów.',
  },
  cat: {
    shoes: 'Buty',
    hoodies: 'Bluzy/Swetry',
    tshirts: 'Koszulki',
    jackets: 'Kurtki',
    pants: 'Spodnie/Szorty',
    headwear: 'Nakrycia głowy',
    sets: 'Zestawy',
    underwear: 'Bielizna/Majtki',
    jersey: 'Koszulka sportowa',
    accessories: 'Akcesoria',
    bags: 'Torby',
    belts: 'Paski',
    perfumes: 'Perfumy',
    other: 'Inne',
  },
};